import { Theme, webLightTheme } from '@fluentui/react-components';

export const fluentWebThemeLight: Theme = {
  ...webLightTheme,

  colorCompoundBrandStroke: '#d60b55',
};
